import React, { useEffect, useState, MouseEvent } from 'react';
import { StyledForm, StyledSelect } from 'pages/Race/SendAffiliateRequest/SendAffiliateRequest.styled';
import { Button, Flex, Input, P } from 'ui';
import { useForm, useWatch } from 'react-hook-form';
import { useAppDispatch, useUserSelector } from 'store';
import { StyledH1 } from 'pages/Race/Race/Race.styled';
import { sendLeaderForm } from 'store/slices/race/actionAsync';
import { StepTwo } from 'pages/Race/SendLeaderRequest/components/StepTwo';
import { StepOne } from 'pages/Race/SendLeaderRequest/components/StepOne';

export interface IFormData {
  username: string;
  name: string;
  contact: string;
  type: 'TG' | 'WA';
  audience: number;
  usdt: number;
  additional: string;
}

export const SendLeaderRequest: React.FC = () => {
  const [step, setStep] = useState(1);
  const { username } = useUserSelector();
  const { register, getValues, formState, clearErrors, control, handleSubmit, setError, setValue } = useForm<IFormData>(
    {
      defaultValues: {
        username,
        name: username,
        type: 'TG',
      },
    },
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (username) {
      setValue('username', username);
    }
  }, [username]);

  const type = useWatch({ name: 'type', control });

  const nextStep = (e?: MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    clearErrors();
    const audience = getValues('audience');
    const contact = getValues('contact');
    const usdt = getValues('usdt');

    if (!contact || contact.length === 0) {
      setError('contact', { message: 'Can`t be empty' });
      return;
    }

    if (!audience || audience === 0) {
      setError('audience', { message: 'Can`t be empty' });
      return;
    }

    if (!usdt || usdt === 0) {
      setError('usdt', { message: 'Can`t be empty' });
      return;
    }

    setStep((prevState) => prevState + 1);
  };

  const onSubmit = async (data: IFormData) => {
    try {
      await dispatch(sendLeaderForm(data));
      nextStep();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      {step === 1 && <StepOne register={register} formState={formState} setValue={setValue} type={type} />}
      {step === 2 && <StepTwo />}
    </StyledForm>
  );
};
